import { Button } from "@/components/common";

const CtaSection = () => {
  return (
    <section className="py-10 sm:py-20 bg-[#1976D2]">
      <div className="max-w-[132rem] mx-auto px-4 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-6 sm:items-center md:flex-row">
          <div>
            <h2 className="text-[2rem] sm:text-[3rem] md:text-[4.2rem] font-bold text-white mb-3 sm:mb-6">
              사용해보고 결정하세요
            </h2>

            <p className="text-[1.3rem] sm:text-[1.6rem] md:text-[1.8rem] text-white">
              복잡한 도입 고민은 끝, 손쉽게 경험해보고 온라인으로 계약하세요
            </p>
          </div>
          <div className="flex flex-col gap-6">
            <Button
              to="/service/submit"
              variant="outline"
              size="lg"
              className=" bg-white py-5 text-[1.3rem] font-semibold rounded-full hover:bg-navy  hover:text-white transition-colors flex justify-between items-center "
            >
              서비스 신청하기
              {/* 아이콘 원 */}
              <span className="flex items-center justify-center ml-8 rounded-full w-9 h-9 bg-black/80">
                <span className="material-icons-round text-[1.4rem] text-white">north_east</span>
              </span>
            </Button>
            <Button
              to="/voc/submit"
              size="lg"
              className="flex items-center justify-between py-5 text-white transition-colors bg-transparent border rounded-full hover:bg-navy"
            >
              <span>도입 상담</span>

              {/* 아이콘 원 */}
              <span className="flex items-center justify-center rounded-full w-9 h-9 bg-white/20">
                <span className="material-icons-round text-[1.4rem] text-white">north_east</span>
              </span>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
